// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Rect} from './rect.js'

export class SetRect {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): SetRect {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsSetRect(bb: flatbuffers.ByteBuffer, obj?: SetRect): SetRect {
    return (obj || new SetRect()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsSetRect(bb: flatbuffers.ByteBuffer, obj?: SetRect): SetRect {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new SetRect()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  value(obj?: Rect): Rect | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Rect()).__init(this.bb_pos + offset, this.bb!) : null
  }

  static startSetRect(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, valueOffset, 0)
  }

  static endSetRect(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }

  static createSetRect(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset): flatbuffers.Offset {
    SetRect.startSetRect(builder)
    SetRect.addValue(builder, valueOffset)
    return SetRect.endSetRect(builder)
  }
}
